import RecaptchaInitializerBase from "./RecaptchaInitializerBase";

declare const gRecaptchaSiteKey: any; // use type 'any' to work around named elements being used as 'document' properties
declare const grecaptcha: any;

export default class RecaptchaV2Initializer extends RecaptchaInitializerBase {
    private widgetId: number | null = null;
    private callback: (response: string) => void;
    private recaptchaContainer: JQuery;

    public init(jq: JQueryStatic, callback: (response: string) => void): void {
        if (this.widgetId !== null) {
            this.callback = callback;
            // sometimes repetitive call to .execute will not call the callback, and it is possible to reset captcha to fix that
            // however that seems to be always causing captcha to present a challenge to solve
            // grecaptcha.reset(this.widgetId);
            grecaptcha.execute(this.widgetId);
        } else {
            callback(null);
        }
    }

    public prepareContainer(jq: JQueryStatic, container: JQuery): void {
        if (!this.recaptchaContainer) {
            const captchaV2Container = jq(`<div class="recaptcha-v2"></div>`);
            jq("body").append(captchaV2Container);
            this.recaptchaContainer = captchaV2Container;
        }

        if (typeof grecaptcha !== "undefined") {
            this.prepareTextContainer(jq, container);
            if (this.widgetId !== null) {
                return;
            }
            let siteKey: string;
            if (typeof gRecaptchaSiteKey === "string" && gRecaptchaSiteKey) {
                siteKey = gRecaptchaSiteKey;
            } else {
                siteKey = jq("#gRecaptchaSiteKey").val() as string;
            }
            grecaptcha.ready(() => {
                if (this.widgetId == null) {
                    this.widgetId = grecaptcha.render(this.recaptchaContainer.get(0), {
                        "sitekey": siteKey,
                        "size": "invisible",
                        "expired-callback": this.resetCaptcha.bind(this),
                        "callback": this.captchaCallback.bind(this),
                    });
                }
            });
        }
    }

    private captchaCallback(response: string): void {
        if (this.callback) {
            this.callback(response);
        }
    }

    private resetCaptcha(): void {
        if (this.widgetId !== null) {
            grecaptcha.reset(this.widgetId);
        }
    }
}
